import { Model } from 'modules/core/lib/mobx-rest'

interface IBankAccount {
  [key: string]: any
}

class BankAccount extends Model<IBankAccount> {
  static urlRoot() {
    return '/bank_accounts'
  }
}

export default BankAccount
